/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/label-has-for */
import { InputWrapperStyles } from '@/themes/globalStyles';

interface FormInputProps {
  backgroundcolor: string;
  children: React.ReactNode;
  error: () => string | false;
}

export const InputWrapper = ({
  backgroundcolor,
  children,
  error,
}: FormInputProps) => (
  <InputWrapperStyles
    className="muster-input-wrapper"
    backgroundcolor={backgroundcolor}
    error={!!error()}
    errorMessage={error() || ''}
  >
    <label>
      {children}
    </label>
  </InputWrapperStyles>
);
